module.exports = __webpack_public_path__ + "media/images/flags/1x1/stp-4bd6a5424f6780b573df1d44c57ce202.svg";